import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import InputField from '../../../../utils/InputField';
import { handleSmtpTestMailOpe } from '../BasicOperation';

function SmtpTestMailModal({ data, handleReload, setShowSmtpModal }) {
    const { hostName, username, port, password } = data;
    const { setMessage } = useTemplate();
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        HostName: hostName || '',
        Port: port || 0,
        Username: username || '',
        Password: password || '',
        TestEmail: ''
    });

    const handleTestSmtp = (e) => {
        e?.preventDefault();
        setLoading(true);
        handleSmtpTestMailOpe(formData, setIsError)
            .then(({ title }) => {
                setMessage({ type: 'success', text: title });
                handleReload();
                setShowSmtpModal(false);
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error?.toString(0) });
            });
    };
    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleTestSmtp}>
            <div className="flex flex-col gap-y-2 mb-4">
                <InputField
                    label="Hostname"
                    name="HostName"
                    placeholder="Type Hostname..."
                    formData={formData}
                    readOnly
                />
                <InputField
                    label="Port"
                    name="Port"
                    placeholder="Type Port..."
                    formData={formData}
                    readOnly
                />
                <InputField
                    label="Username"
                    name="Username"
                    placeholder="Type Username..."
                    formData={formData}
                    readOnly
                />
                <InputField
                    label="Test Email"
                    name="TestEmail"
                    placeholder="Ex: test@example.com"
                    formData={formData}
                    onChange={(e) => setFormData((d) => ({ ...d, TestEmail: e.target.value }))}
                />
            </div>

            <div className="flex gap-x-2 justify-end">
                <ButtonCancel title="Cancel" onClick={() => setShowSmtpModal(false)} />
                <ButtonPrimary title="Test" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default SmtpTestMailModal;
